import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Component, OnInit } from '@angular/core';
import { DigitalService } from '../../../core/services/digital.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Message } from '../../../core/class/message';

interface ModelSaveOrder {
  transactionId: string; // Mã giao dịch thanh toán qua cổng thanh toán online -- Nếu thanh toán COD thì giá trị này null
  customerName: string; // Họ tên khách hàng 
  phone: string; // Số điện thoại
  email: string; // Email khách hàng
  provinceId: number; // Id Tỉnh/ Thành phố
  provinceName: string;  // Tên Tỉnh
  districtId: number; // Id Quận/ Huyện 
  districtName: string; // Tên Huyện
  wardId: number;  // Id Phường/ Xã
  wardName: string;  // Tên xã
  deliveryAddress: string; // Địa chỉ nhận hàng (maxlength = 255 kí tự)
  installType: number; // Hình thức lắp đặt: (0: Viettel lắp ) (1: Tự lắp đặt mặc định 1 với ViettelCA)
  installPrice: number; // Chi phí lắp đặt (maxlength = 9 kí tự) -- Set: null
  paymentMethod: number; //Phương thức thanh toán (1: COD) (2: VTPAY) (3: BANKPLUS) (4: VISA) (5: ATM) (6: OTHER)
  paymentTypeStr: string;
  feeShipping: number; // Phí vận chuyển  (maxlength = 9 kí tự)
  note: string; // Ghi chú (maxlength = 255 kí tự)
  total: number; // Tổng chi phí đơn hàng (maxlength = 9 kí tự)
  invoice: number; // Xuất hóa đơn hay không: (1: Có) (0: Không) (Nếu giá trị bằng 1 sẽ validate bắt buộc nhập các trường: taxCode, companyName, companyAddress)
  taxCode: string; // Mã số thuế
  companyName: string;  // Tên công ty
  companyAddress: string; // Địa chỉ công ty
  quantity: number; // Số lượng
  amount: number; // Tổng tiền của từng gói sản phẩm
  discount: number; // Giảm giá
  vat: number; // Thuế 
  orderDate: string;  // Ngày đặt hàng
  type: number;
  otp: number;
  orderCode: string;
  id: number;
  listPackage: ListPackage[];  //Gói
}

//Gói
interface ListPackage {
  packageId: string; // Id gói cước
  packageCode: String; // Mã gói cước
  packageName: string; // Tên gói cước
  quantity: number; // Tổng số lượng gói cước - Sum(listPackage.quantity)
  price: number; // Đơn giá gói cước (maxlength = 9 kí tự)
  duration: number; // Thời hạn gói cước (maxlength = 9 kí tự)
  amount: number; // Tổng tiền hàng - Sum(listPackage.amount)
}

@Component({
  selector: 'app-detail-order',
  templateUrl: './detail-order.component.html',
  styleUrls: ['./detail-order.component.scss']
})
export class DetailOrderComponent implements OnInit {

  modelSaveOrder: ModelSaveOrder;
  typePayment: any;
  total: number = null;
  totalOrderAmount: number = null;
  totalCostOrder: number = null;
  isDateTimeNowConfirmOrder: Date = new Date();
  phoneNumberLocalStorage: any;
  orderCodeLocalStorage: any;
  phoneNumberVTPay: any;
  orderCodeVTPay: any;

  urlConfirmVTPay: any;


  constructor(
    private digitalService: DigitalService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private message: Message,
    private spinnerService: Ng4LoadingSpinnerService,
  ) {
    this.modelSaveOrder = {
      transactionId: "",
      customerName: "",
      phone: "",
      email: "",
      provinceId: null,
      provinceName: "",
      districtId: null,
      districtName: "",
      wardId: null,
      wardName: "",
      deliveryAddress: "",
      installType: 1,
      installPrice: 0,
      paymentMethod: 1,
      paymentTypeStr: "COD",
      feeShipping: 0,
      note: "",
      total: 2741000,
      invoice: 1,
      taxCode: "",
      companyName: "",
      companyAddress: "",
      quantity: 1,
      amount: 2741000,
      discount: 0,
      vat: 0,
      orderDate: "",
      type: 1,
      otp: 0,
      orderCode: "",
      id: 0,
      listPackage: []
    }
  }

  ngOnInit() {
    this.spinnerService.show();
    this.phoneNumberLocalStorage = JSON.parse(localStorage.getItem('_phone'));
    this.orderCodeLocalStorage = JSON.parse(localStorage.getItem('_orderCode'));
    this.phoneNumberVTPay = this.activatedRoute.snapshot.paramMap.get('phone');
    this.orderCodeVTPay = this.activatedRoute.snapshot.paramMap.get('orderCode');

    if (this.phoneNumberVTPay !== null && this.phoneNumberVTPay !== undefined && this.orderCodeVTPay !== null && this.orderCodeVTPay !== undefined) {
      console.log("::::: ViettelPay");
      this.confirmViettelpay();
    }
    else {
      console.log("::::: MethodCOD");
      this.getOrderDetails(this.phoneNumberLocalStorage, this.orderCodeLocalStorage);
    }
  }

  confirmViettelpay() {
    const finIndexChart = this.router.url.indexOf('/digital/detail-order/');
    this.urlConfirmVTPay = this.router.url.substring(finIndexChart + 22, this.router.url.length - 1);

    this.digitalService.confirmViettelpay(this.urlConfirmVTPay).subscribe(rs => {
      if (rs !== null && rs !== undefined && rs !== '') {
        this.getOrderDetails(this.phoneNumberVTPay, this.orderCodeVTPay);
      }
    });

  }

  //get order details.
  getOrderDetails(phone, orderCode) {
    this.spinnerService.show();
    this.digitalService.getOrderDetails(phone, orderCode).subscribe(rs => {
      if (rs !== null && rs !== undefined) {
        //thành công thì xóa đơn hàng trong Giỏ.
        localStorage.removeItem('arrayPackageStoreLocal');
        localStorage.removeItem('cities_digital');
        localStorage.removeItem('wards_digital');
        localStorage.removeItem('districts_digital');
        localStorage.removeItem('modelSaveOrder');
        localStorage.removeItem('typePayment');
        const result = (JSON.parse(rs)).data.data;
        if (result !== null && result !== undefined) {
          this.modelSaveOrder.customerName = result.orderInfo.customerName == null ? '' : result.orderInfo.customerName;
          this.modelSaveOrder.phone = result.orderInfo.phone == null ? '' : result.orderInfo.phone;
          this.modelSaveOrder.email = result.orderInfo.email == null ? '' : result.orderInfo.email;
          this.modelSaveOrder.deliveryAddress = result.orderInfo.address == null ? '' : result.orderInfo.address;
          this.modelSaveOrder.taxCode = result.orderInfo.taxCode == null ? '' : result.orderInfo.taxCode;
          this.modelSaveOrder.provinceName = result.orderInfo.provinceName == null ? '' : result.orderInfo.provinceName;
          this.modelSaveOrder.districtName = result.orderInfo.districtName == null ? '' : result.orderInfo.districtName;
          this.modelSaveOrder.wardName = result.orderInfo.wardName == null ? '' : result.orderInfo.wardName;
          this.modelSaveOrder.note = result.orderInfo.note == null ? '' : result.orderInfo.note;
          this.modelSaveOrder.companyName = result.orderInfo.companyName == null ? '' : result.orderInfo.companyName;
          this.modelSaveOrder.companyAddress = result.orderInfo.companyAddress == null ? '' : result.orderInfo.companyAddress;
          this.modelSaveOrder.orderCode = result.orderInfo.orderCode == null ? '' : result.orderInfo.orderCode;
          this.modelSaveOrder.orderDate = result.orderInfo.orderDate == null ? '' : result.orderInfo.orderDate;
          this.modelSaveOrder.paymentMethod = result.orderInfo.paymentMethod == null ? '' : result.orderInfo.paymentMethod;
          this.modelSaveOrder.listPackage = result.listPackage == null ? [] : result.listPackage;

          //tổng số lượng //Tổng tiền đơn hàng //Tổng chi phí đơn hàng
          if (this.modelSaveOrder.listPackage.length > 0 && this.modelSaveOrder.listPackage != null) {
            this.modelSaveOrder.listPackage.forEach(x => {
              this.total = this.total + x.quantity;
              this.totalOrderAmount = this.totalOrderAmount + x.amount;
              this.totalCostOrder = this.totalOrderAmount;
              return x;
            });
          }
          this.spinnerService.hide();
        }
      }
    }, (error) => {
      console.log(error);
      this.toastr.error(this.message.getMessage('messages.expired_date_order'));
    });

  }
}
